import React from 'react';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import GreyBox from './GreyBox';
import { COLORS } from '../../../Constant/COLORS';

const CustomTable = ({ componentRef,tableHeadings, children, ...rest }) => (
  <GreyBox ref={componentRef} px={5} maxWidth='100%' {...rest}>
    <TableContainer sx={{ maxHeight: 1 }} >
      <Table stickyHeader>
        <TableHead sx={{ whiteSpace: 'nowrap' }}>
          <TableRow>
            {tableHeadings.map(tableCell => (
              <TableCell key={tableCell} sx={{ bgcolor: COLORS.surfaceAlt }}>
                {tableCell}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  </GreyBox>
);

CustomTable.propTypes = {
  tableHeadings: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  children: PropTypes.any,
};

export default React.memo(CustomTable);
